<div class="app-panel app-panel--nested">
  <div class="app-panel__header">
    <h4 class="app-panel__title">{{ i18n().t('checklistCreator.definition.multiscaleTitle') }}</h4>
  </div>
  <div class="checklist-creator__array-section">
    @for (option of options().controls; track $index) {
      <div class="checklist-creator__array-row" [formGroup]="asFormGroup(option)">
        <label class="app-field">
          <span class="app-field__label">{{ i18n().t('checklistCreator.fields.optionId') }}</span>
          <input type="text" formControlName="optionId" />
        </label>
        <label class="app-field">
          <span class="app-field__label">{{ i18n().t('checklistCreator.fields.optionTitle') }}</span>
          <input type="text" formControlName="title" />
        </label>
        <label class="app-field">
          <span class="app-field__label">{{ i18n().t('checklistCreator.fields.optionScore') }}</span>
          <input type="number" formControlName="score" />
        </label>
        @if (!isReadOnly()) {
          <button class="secondary-button" type="button" (click)="removeOptionRequested()($index)">{{ i18n().t('checklistCreator.actions.remove') }}</button>
        }
      </div>
    }
    @if (!isReadOnly()) {
      <button class="secondary-button" type="button" (click)="addOptionRequested()()">{{ i18n().t('checklistCreator.actions.addOption') }}</button>
    }
  </div>
</div>
